const REFUND_WINDOW_DAYS = 120;
const DAY_MS = 24 * 60 * 60 * 1000;

function merchantKey(transaction) {
	return `${(transaction.where || '').trim().toLowerCase()}|${Math.abs(transaction.amount)}`;
}

/**
 * Pairs each credit with the charge it most likely refunds: the latest earlier charge at the same
 * merchant for exactly the opposite amount, within REFUND_WINDOW_DAYS, that no other credit claimed.
 * It is a guess from the numbers alone, so the page words it as "probably".
 *
 * @returns {Map<Transaction, {refund: Transaction}|{refunds: Transaction}>} both sides of each pair
 */
export default function findRefunds(transactions) {
	const chargesByKey = new Map();
	const credits = [];
	for(const transaction of transactions) {
		if(transaction.deleted || !transaction.amount || !transaction.transaction_date || !transaction.where) {
			continue;
		}
		if(transaction.amount > 0) {
			const key = merchantKey(transaction);
			if(!chargesByKey.has(key)) {
				chargesByKey.set(key, []);
			}
			chargesByKey.get(key).push(transaction);
		} else {
			credits.push(transaction);
		}
	}

	const time = (transaction) => transaction.transaction_date.valueOf();
	credits.sort((a, b) => time(a) - time(b));
	chargesByKey.forEach((charges) => charges.sort((a, b) => time(a) - time(b)));

	const matches = new Map();
	for(const credit of credits) {
		const charges = chargesByKey.get(merchantKey(credit)) || [];
		for(let i = charges.length - 1; i >= 0; i--) {
			const charge = charges[i];
			const age = time(credit) - time(charge);
			if(age < 0 || matches.has(charge)) {
				continue;
			}
			if(age > REFUND_WINDOW_DAYS * DAY_MS) {
				break;
			}
			matches.set(charge, { refund: credit });
			matches.set(credit, { refunds: charge });
			break;
		}
	}
	return matches;
}
